
import { computed } from "@vue/reactivity";
import { useStore } from "vuex";
import { ComputedRef, defineComponent, onBeforeMount, watch } from "vue";
import { Content, ContentComplement } from "./helpers";
import { ComplementaryContentType } from "../../../../domain/entities/content/complementary_content";
import { dispatchError } from "../../utils/error_handling";

export default defineComponent({
  name: "ContentComplements",
  setup() {
    const store = useStore();

    const currentContent: ComputedRef<Content> = computed(
      () => store.getters["content_module/currentContent"]
    );
    watch(
      () => currentContent.value,
      async () => await onCurrentContentChange()
    );

    onBeforeMount(async () => {
      await loadComplements();
    });

    const onCurrentContentChange = async () => {
      try {
        await loadComplements();
      } catch (e) {
        console.error("[onCurrentContentChange] Error loadComplements");
        await dispatchError(e);
      }
    };

    const loadComplements = async (): Promise<void> => {
      try {
        await store.dispatch("content_module/complement/loadComplements");
      } catch (e) {
        console.error("[loadComplements] Error ", e);
        throw e;
      }
    };

    const complements: ComputedRef<ContentComplement[]> = computed(
      () => store.getters["content_module/complement/complements"]
    );

    return {
      ComplementaryContentType,
      complements
    };
  }
});
